<script>
    import datosContabilidad from "@/assets/pruebatabla/datosContabilidad.json"
    export default{
        
    setup() {
        return {
            datosContabilidad,
    };
    
}
}
</script>
<!-- <script>
import axios from 'axios';

export default {
  data() {
    return {
      datosContabilidad: null
    }
  },
  async created() {
    try {
      const response = await axios.get('/assets/pruebatabla/datosContabilidad.json');
      this.datosContabilidad = response.data;
    } catch (error) {
      console.error('Error al cargar el JSON:', error);
    }
  }
}
</script> -->


<template>
    <section class="list">

        <div v-for="(item, name) in datosContabilidad" :key="item.name">
            <div >
                <div class="title">

                    <p>{{name}}</p>
                </div>
                <div class="item" v-for="(account,name) in item" :key="account.name">
                    <section class="list">
                        
                        <div class="list--item">
                            <p >{{name}}</p>
                        </div>
                        <div class="cuantity">
                            
                            <p>{{ account }}</p>
                        </div>
                        <div>
                            
                        </div>

                    </section>
                    
                </div>
            </div>
            
        </div>
    </section>

</template>

<style>
    .item{
        border-style: solid solid solid solid;
        border-color: black;
        border-width: 0.01rem;
        
        max-height: 3;
        /* height: 3rem; */
        background-color: antiquewhite
    }
    .list{
        display: grid;
        /* column-gap: 1rem; */
        grid-template-columns: repeat(2,1fr);

    }
    .list--item{
        border-right-style: solid;
    }
    .title{
        background: linear-gradient(to top, gray, 50%, white);
        border-style: solid;
        border-width: .1rem;
        font-size: 1.3rem;
        font-weight: 700;
    }
    .cuantity{
        background-color: rgb(240, 243, 243);
    }
</style>